'use client'

import { useState, useEffect } from 'react';

const COOKIE_PREFS_KEY = 'cookie-preferences';

type consentType = {
    desempenho: boolean,
    funcionalidades: boolean,
    necessarios: boolean
};

const initialState = {
  desempenho: false,
  funcionalidades: false,
  necessarios: false
}

export const useCookieConsent = () => {
  const [consent, setConsent] = useState<consentType>({...initialState});

  const updateConsent = (newConsent: consentType) => {
    setConsent(newConsent);
    if (typeof window !== 'undefined') {
      localStorage.setItem(COOKIE_PREFS_KEY, JSON.stringify(newConsent));
    }
  };

  useEffect(() => {
    const storedConsent = localStorage.getItem(COOKIE_PREFS_KEY);
    if (storedConsent) {
      setConsent(JSON.parse(storedConsent));
    } else {
      setConsent({...initialState});
    }
  }, []);

  return {
    consent,
    updateConsent,
  };
};